import { Grid, Paper } from "@mui/material";
import { useState } from "react";
import { ENVIRONMENT_LIST } from "./data";
import { AppChip } from "../../../../../components/chips";
import { MultiColorProgressbar } from "../../../../../components/multi-color-progressbar";

function Environment({ data }) {
  const [environmentList, setEnvironmentList] = useState(data?.environment);
  let sum = 0;

  data &&
    data?.environment &&
    Object.keys(data?.environment)
      ?.filter((i) => data?.environment?.[i] > 0)
      .map((i) => {
        sum += data?.environment?.[i];
      });

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        {data?.environment && (
          <Paper sx={{ minHeight: 75, p: 1 }}>
            <Grid container spacing={1}>
              <Grid item>
                <AppChip size="small" label="Cloud Native" />
              </Grid>
              <Grid item xs={12}>
                <MultiColorProgressbar
                  labels={ENVIRONMENT_LIST.filter((env) => {
                    return data?.environment?.[env.field] > 0;
                  }).map((env) => {
                    return {
                      ...env,
                      value: data?.environment[env.field],
                    };
                  })}
                  withLabel
                  elements={ENVIRONMENT_LIST.map((env) => {
                    return {
                      value: (data?.environment?.[env.field] / sum) * 100,
                      color: env.color,
                    };
                  })}
                />
              </Grid>
            </Grid>
          </Paper>
        )}
      </Grid>
    </Grid>
  );
}

export default Environment;
